import React from "react";
import { Tooltip, createStyles, makeStyles, Theme } from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    headingImage: {
      width: 16,
      height: 16,
      objectFit: "contain",
      cursor: "pointer",
      verticalAlign: "top",
    }
  })
);

export interface expandType{
    clicked:any, keyDown:any
}

export const OpenInNewModal = (props: expandType) => {
    const {clicked, keyDown} = props;
  const classes = useStyles();
  const openNew = require("../../images/ic-outline-open-in-new.svg")
  return (
    <Tooltip title={"Open in new modal"}>
      <img
        className={classes.headingImage}
        src={openNew}
        alt={"Open"}
        onClick={clicked}
        onKeyDown={keyDown}
        data-testid="outline-open-in-new"
      />
    </Tooltip>
  );
};
